<template>
<div class="AppHeader">
  <div class="AppHeader-block is-hidden-tablet">
    <b-button type="is-dark" icon-right="menu" @click="toggle('menu')" />
  </div>
  <div class="AppHeader-block">
    <img src="/img/leonisa.svg" alt="Leonisa" width="120" class="is-hidden-mobile">
    <img src="/img/leonisa-icon.svg" alt="Leonisa" width="32" class="is-hidden-tablet">
    <p style="line-height: 8px;"><label style="font-size: 10px; color: white;" >Versión 1.22.1021</label></p>
  </div>
  <div class="AppHeader-block AppHeader-block--sep is-hidden-mobile"></div>
  <div class="AppHeader-block AppHeader-block--search">
    <b-field>
      <p class="control">
        <b-dropdown v-model="filterBy" aria-role="list">
          <button class="button is-light" slot="trigger">
            <b-icon :icon="filterBy.icon"></b-icon>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item v-for="(filter, index) in filters" :value="filter" :key="index">
            <div class="media">
              <b-icon class="media-left" :icon="filter.icon"></b-icon>
              <div class="media-content">
                <h3>{{filter.label}}</h3>
              </div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </p>
      <b-input type="text" placeholder="Buscar..." v-model="filterText" v-debounce:300ms.fireonempty="search" expanded></b-input>
    </b-field>
  </div>
  <div class="AppHeader-block AppHeader-block--sep is-hidden-mobile"></div>
  <div class="AppHeader-block">
    <b-button class="is-dark has-tag" icon-right="shopping" :data-tag="getCart.length" @click="toggle('cart')" />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        menu: false,
        cart: false
      })
    }
  },
  data () {
    return {
      searchToggle: false,
      filterText: '',
      filterBy: {},
      filters: [
        {
          icon: 'barcode-scan',
          tag: 'parent',
          label: 'Referencia',
          char: '#'
        },
        {
          icon: 'shopping-search',
          tag: 'title',
          label: 'Nombre',
          char: '@'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getCart'
    ])
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.filterText !== '') this.search()
      }
    }
  },
  mounted () {
    this.filterBy = this.filters[0]
  },
  methods: {
    ...mapActions([
      'setFilterBy'
    ]),
    toggle (who) {
      this.value[who] = !this.value[who]
      this.$emit('input', this.value)
    },
    search () {
      this.setFilterBy({
        where: this.filterBy.tag,
        what: this.filterText
      })
    },
    closeSearch () {
      this.searchToggle=!this.searchToggle
      this.filterText=''
      this.search()
    }
  }
}
</script>

<style scoped lang="scss">
.AppHeader {
  display: flex;
  align-items: center;
  height: 52px;
  width: 100%;
  background-color: #0a0a0a;
  color: #fff;
  margin: 0 auto;
  min-height: 3.25rem;
  top: 0;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 30;
  &-block {
    margin: 0 10px;
  }
  &-block--search {
    flex: 1;
  }
}
</style>
